import {Popup} from "~components/popup/popup";

class Basket {
	add(id, quantity, callback) {
		$('body').addClass('body--loading');

		$.post(
			'/local/ajax/basket.php',
			{
				action: 'add',
				offer_id: id,
				quantity: quantity
			}
		).done(function(response) {
			if (response.status === 'ok') {
				if (
					(typeof window.Counters !== 'undefined')
					&& response.dataLayer
				) {
					window.Counters.GA_BasketActions(response.dataLayer);
				}

				if (callback) {
					callback(response);
				}
			}

			$('body').removeClass('body--loading');

			if (response.status === 'error') {
				console.error(response.message);

				if (typeof window.Popup !== 'undefined') {
					window.Popup.errorMessage();
				}
			}
		})
	}
}

window.Basket = new Basket();
